import React, { Component, Fragment } from "react";
import PlayerService from "../../services/players";

import { toast } from "react-toastify";

import "./styles.css";
import LoadingMask from "../../components/LoadingMask";
import PlayerList from "./PlayerList";
import AuthService from "../../services/auth";

class Players extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      activeCategoryIndex: 0,
      isLoading: false,
    };
  }

  registerVote = (players, captcha) => {
    const { activeCategoryIndex, categories } = this.state;
    const { history } = this.props;

    this.setState({ isLoading: true });

    let newIndex = activeCategoryIndex + 1;

    PlayerService.registerVote(players, 1, captcha)
      .then((response) => {
        toast(response.data.data, {
          position: "top-right",
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          hideProgressBar: true,
        });

        if (newIndex >= 1) {
          history.push("/votes");
        }

        this.setState({
          isLoading: false,
          activeCategoryIndex: newIndex,
        });
      })
      .catch((e) => {
        if (e.response.status === 400) {
          return history.push("/votes-closed");
        }

        toast(e.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          hideProgressBar: true,
        });

        if (newIndex >= 1) {
          history.push("/error");
        }

        this.setState({
          isLoading: false,
          activeCategoryIndex: newIndex,
        });
      });
  };

  render() {
    const { activeCategoryIndex, isLoading } = this.state;

    return (
      <div className="PageContainer">
        {isLoading && <LoadingMask />}

        <h2 className="Players__title">
          <img
            src="https://static.draft5.gg/jovem-do-ano/logo.png"
            width="200"
            alt="Logo"
          />
          <br />
          Vote no jovem do Ano
        </h2>
        <h4 className="Players__subtitle">Selecione abaixo</h4>

        <PlayerList
          category={1}
          onRegisterVote={(playerId, captcha) => {
            this.registerVote(playerId, captcha);
          }}
        />
      </div>
    );
  }
}

export default Players;
